module.exports = "/cyber/_next/static/images/steam-8416a03a9173afde6d5880f3ee2bf007.jpg";